
/**
 * esto es paral os empleados
 * pero la función traerExcel (que realmente es el que genera el pdf) la usa el admin
 */

import { useState, useEffect } from 'react'
import url from '../api/url'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import { elToast } from '../functions/Alerta'

export default function useHistorialSalidas({ fromAdmin = false }) {
    const [listaHistorial, setListaHistorial] = useState([])
    const { URL: URL_MIO, SERVIDOR } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [cargando, setCargando] = useState(false)



    function traerHistorial() {

        if (!objLogueado.email) {
            return
        }

        setCargando(true)

        var body = new FormData()
        body.append('funcion', 'historialSalidas')
        body.append('email', objLogueado.email)

        fetch( URL_MIO, {
            method: 'post',
            body: body
        })
        .then(respuesta => respuesta.json())
        .then(datos => setListaHistorial(datos))
        .catch(err => alert('Hay problemas al traer tu historial de salidas.'))
        .finally(() => setCargando(false))
    }


	function traerExcel(id) {

		elToast('Generando archivo...', 'esperar')

        let body = new FormData()
        body.append('id', id)

        fetch(SERVIDOR+'/funciones/exportar_formato_salida_pdf.php', {
            body,
            method: 'POST'
        })
            .then(response => response.blob())
            .then(blob => {
                // Crea un enlace de descarga
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'Formato_de_salida.pdf';
                link.click();
                elToast('Archivo generado exitosamente', 'exito')
            })
            .catch(e => {
                elToast('Hubo un error al generar el archivo de excel, por favor intentalo nuevamente', 'error')
            })
    }


    useEffect(() => {
        if (fromAdmin) {
            traerHistorial()
        }
        // eslint-disable-next-line
    }, [])

    return {
        listaHistorial, cargando, traerExcel
    }
}
